import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Actions } from '../../types';
import { ExistingMatchSelection, MatchSelection } from './types';

export const SET_ADDITIONAL_COMMENTS = 'SET_ADDITIONAL_COMMENTS';
export const setAdditionalComments = (additionalComments: string): Actions => ({
  type: SET_ADDITIONAL_COMMENTS,
  additionalComments,
});

export const SET_SELECTED_COUNTRIES = 'SET_SELECTED_COUNTRIES';
export const setSelectedCountries = (countries: string[] | undefined): Actions => ({
  type: SET_SELECTED_COUNTRIES,
  countries,
});

export const SET_SELECTED_MATCHES = 'SET_SELECTED_MATCHES';
export const setSelectedMatches = (selectedMatches: { [key: string]: MatchSelection }): Actions => ({
  type: SET_SELECTED_MATCHES,
  selectedMatches,
});

export const SET_EXISTING_MATCHES = 'SET_EXISTING_MATCHES';
export const setExistingMatches = (existingMatches: { [key: string]: ExistingMatchSelection }): Actions => ({
  type: SET_EXISTING_MATCHES,
  existingMatches,
});

export const SET_COOPERATIVE_MATCH = 'SET_COOPERATIVE_MATCH';
export const setCooperativeMatch = (cooperativeMatch: boolean): Actions => ({
  type: SET_COOPERATIVE_MATCH,
  cooperativeMatch,
});

export const SET_SPECIAL_NOTES = 'SET_SPECIAL_NOTES';
export const setSpecialNotes = (specialNotes: string[]): Actions => ({
  type: SET_SPECIAL_NOTES,
  specialNotes,
});

export const SET_ERROR = 'SET_ERROR';
export const setError = (error: ApiError): Actions => ({
  type: SET_ERROR,
  error,
});
